import tracking from '../../../utils/tracking';

var PRODUCT_TOUR_SCROLL_DEPTH_TRACK_EVENT_FIRED = false;

window.addEventListener("scroll", () => {
  if (
    !PRODUCT_TOUR_SCROLL_DEPTH_TRACK_EVENT_FIRED &&
    window.scrollY / (document.body.clientHeight - window.innerHeight) >= 0.7
  ) {
    PRODUCT_TOUR_SCROLL_DEPTH_TRACK_EVENT_FIRED = true;
    tracking.trackEvent("70_perc_scroll");
  }
});
